import r from"./AppActions.css.js";import{jsx as t}from"react/jsx-runtime";function i(i){var s=i.children;return t("div",{className:r.appActions,children:s})}export{i as default};
